import React, { useMemo } from 'react'

//* HOC's
import { withUIContext } from 'context'

//* Components
import FancyButton from 'components/common/FancyButton'
import Text from 'components/common/Text'
import ShopItem from 'components/pages/Shop/ShopItem'

//* Style
import ShopSectionStyle from './style'

//* Config
import { config } from 'helpers'

const ShopSection = ({ products, winWidth }) => {
	let normalProducts = []
	let mediumProducts = []

	const storeNormalProducts = useMemo(() => {
		const countNormalItems = winWidth < 1440 && winWidth >= 1024 ? products?.length - 2 : products?.length

		for (let i = 1; i < countNormalItems; i++) {
			const element = products[i]
			normalProducts.push(<ShopItem productData={element} key={i} className='normal' />)
		}

		return normalProducts
	}, [products, winWidth])

	const storeMediumProducts = useMemo(() => {
		for (let i = 3; i < products?.length; i++) {
			const element = products[i]
			mediumProducts.push(<ShopItem productData={element} key={i} className='medium' />)
		}
		return mediumProducts
	}, [products])

	return products ? (
		<ShopSectionStyle>
			<Text tag='h3' className='terminaBold orange' text='shop' />
			<div className='productsWrap FlexBoxColumn'>
				<div className='FlexBox bigAndNormal'>
					<ShopItem productData={products?.[0]} className='bigItem' />
					<div className='FlexBoxContainer otherProductsWrap'>{storeNormalProducts}</div>
				</div>
				{winWidth < 1440 && winWidth >= 1024 && <div className='FlexBox'>{storeMediumProducts}</div>}
			</div>
			<FancyButton isButtonChangePage={true} route={config.routes.shop.path} content='viewAll' />
		</ShopSectionStyle>
	) : null
}

export default withUIContext(ShopSection, ['winWidth'])
